import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Shipments from './pages/Shipments';
import CreateShipment from './pages/CreateShipment';
import ShipmentDetail from './pages/ShipmentDetail';
import Rates from './pages/Rates';
import Users from './pages/Users';
import Customers from './pages/Customers';
import Reports from './pages/Reports';
import Languages from './pages/Languages';
import Settings from './pages/Settings';
import Slideshows from './pages/Slideshows';
import MobileTranslations from './pages/MobileTranslations';
import MobileUsers from './pages/MobileUsers';
import AppVersion from './pages/AppVersion';
import ExchangeRates from './pages/ExchangeRates';
import NewsFeed from './pages/NewsFeed';
import Layout from './components/Layout';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="shipments" element={<Shipments />} />
          <Route path="shipments/create" element={<CreateShipment />} />
          <Route path="shipments/:id" element={<ShipmentDetail />} />
          <Route path="rates" element={<Rates />} />
          <Route path="users" element={<Users />} />
          <Route path="customers" element={<Customers />} />
          <Route path="reports" element={<Reports />} />
          <Route path="languages" element={<Languages />} />
          <Route path="settings" element={<Settings />} />
          <Route path="slideshows" element={<Slideshows />} />
          <Route path="mobile-translations" element={<MobileTranslations />} />
          <Route path="mobile-users" element={<MobileUsers />} />
          <Route path="app-version" element={<AppVersion />} />
          <Route path="exchange-rates" element={<ExchangeRates />} />
          <Route path="news-feed" element={<NewsFeed />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
